import { SpaceProps } from '@wrisk/styled-system'
import React, { FunctionComponent } from 'react'

import { getCoverLevelOption } from '../../../domain'
import { TKey } from '../../../infrastructure/internationalisation'
import { usePolicy } from '../../product/policy/PolicyProvider'
import { PromotionBanner } from './PromotionBanner'

const tKey = TKey('components.promotion-banner')

export const PolicyPromotionBanner: FunctionComponent<SpaceProps> = (props) => {
  const {
    policy: {
      currentPolicyVersion: { quote },
    },
  } = usePolicy()

  const promotion = getCoverLevelOption(quote)?.promotion

  return quote.promoCode && promotion ? (
    <PromotionBanner tKey={tKey} promoCode={quote.promoCode} {...props} />
  ) : null
}
